<template>
  <div>
    <div v-if="!dataLoaded">
      <div class="row">
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
        <div class="col-md-4">
          <div>
            <b-skeleton height="140px"></b-skeleton>
          </div>
          <div class="mt-3">
            <b-skeleton height="38px"></b-skeleton>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <b-skeleton-table
            :rows="5"
            :columns="4"
            :table-props="{ bordered: true, striped: true }"
          ></b-skeleton-table>
        </div>
      </div>
    </div>
    <div v-if="dataLoaded">
      <div>
        <div class="row">
          <div class="col-md-4">
            <b-card no-body bg-variant="light-warning" class="mb-lg-0">
              <div class="card-body pl-0 pr-0">
                <div class="d-flex align-items-center p-5">
                  <div class="mr-6">
                    <span class="svg-icon svg-icon-warning svg-icon-7x">
                      <inline-svg
                        src="media/svg/icons/Shopping/Chart-line1.svg"
                      />
                    </span>
                  </div>
                  <div class="d-flex flex-column">
                    <span
                      class="text-dark text-hover-warning font-weight-bold font-size-h4 mb-3"
                      >تعداد معرفی ها</span
                    >
                    <div class="text-dark-75">
                      {{ summery.referral_count }} عدد
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
            <b-button
              class="mt-3 mb-3"
              v-if="canCopy"
              @click="copy(appId)"
              variant="light-warning"
              block
              >دریافت لینک معرفی</b-button
            >
          </div>
          <div class="col-md-4">
            <!--begin::Callout-->
            <b-card no-body bg-variant="light-success" class="mb-lg-0">
              <div class="card-body pl-0 pr-0">
                <div class="d-flex align-items-center p-5">
                  <!--begin::Icon-->
                  <div class="mr-6">
                    <span class="svg-icon svg-icon-success svg-icon-7x">
                      <!--begin::Svg Icon | path:assets/media/svg/icons/Home/Mirror.svg-->
                      <inline-svg src="media/svg/icons/Shopping/Wallet.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </div>
                  <!--end::Icon-->
                  <!--begin::Content-->
                  <div class="d-flex flex-column">
                    <span
                      class="text-dark text-hover-warning font-weight-bold font-size-h4 mb-3"
                      >درآمدهای درحال تسویه</span
                    >
                    <div class="text-dark-75">
                      {{ Number(summery.unsettled).toLocaleString() }}
                      ریال
                    </div>
                  </div>
                  <!--end::Content-->
                </div>
              </div>
            </b-card>
            <!--end::Callout-->
            <b-button
              class="mt-3 mb-3"
              v-b-modal.modal-1
              variant="light-success"
              block
              >لیست تسویه ها</b-button
            >
          </div>

          <div class="col-md-4">
            <!--begin::Callout-->
            <!-- <div bg-variant='success' class="card card-custom mb-lg-0">
              
            </div> -->
            <b-card
              no-body
              bg-variant="light-warning"
              class="mb-lg-0"
              style="height: calc(100% - 58px)"
            >
              <div class="card-body pl-0 pr-0">
                <div class="d-flex align-items-center p-5">
                  <!--begin::Icon-->
                  <div class="mr-6">
                    <span class="svg-icon svg-icon-warning svg-icon-7x">
                      <!--begin::Svg Icon | path:assets/media/svg/icons/Home/Mirror.svg-->
                      <inline-svg src="media/svg/icons/Shopping/Dollar.svg" />
                      <!--end::Svg Icon-->
                    </span>
                  </div>
                  <!--end::Icon-->
                  <!--begin::Content-->
                  <div class="d-flex flex-column">
                    <span
                      class="text-dark text-hover-warning font-weight-bold font-size-h4 mb-3"
                      >درآمدهای تسویه نشده</span
                    >
                    <div class="text-dark-75">
                      {{ Number(summery.deposit).toLocaleString() }} ريال
                    </div>
                  </div>
                  <!--end::Content-->
                </div>
              </div>
            </b-card>
            <!--end::Callout-->
            <b-button
              class="mt-3 mb-3"
              v-b-modal.modal-2
              @click="show = true"
              variant="light-warning"
              block
              >درخواست تسویه</b-button
            >
          </div>
        </div>
      </div>

      <b-card title="درگاه های زیر مجموعه" sub-title="راهنما:">
        <b-card-text class="guide">
          <li>جهت استفاده از سرویس کسب درآمد ،مراحل زیر را طی نمایید:</li>
          <!-- <dt>Coffee</dt> -->
          <p>1- بر روی گزینه دریافت لینک کلیک نمایید.</p>
          <!-- <dt>Milk</dt> -->
          <p>2- لینک را برای شخص مورد نظر خود ارسال نمایید.</p>
          <p>
            3- از منوی درآمد های تسویه نشده می توانید میزان درآمد خود را مشاهده
            کرده و هر زمان که تمایل داشتید بر روی دکمه درخواست تسویه کلیک کرده و
            با وارد کردن شماره شبا و مبلغ مورد نظر درآمد خود را با شپا تسویه
            نمایید.
          </p>

          <p>
            4- برای مشاهده گزارش تسویه های خود بر روی دکمه ی لیست تسویه ها کلیک
            نمایید.
          </p>

          <li>
            نرخ پورسانت در حال حاضر 50 درصد مبلغ کارمزد به ازای هر تراکنش می
            باشد.
          </li>
          <li>
            درخواست های تسویه در روزهای یکم الی دهم ماه آینده انجام خواهد
            پذیرفت.
          </li>
        </b-card-text>
        <list-table
          :fields="merchants.fields"
          :url="merchants.url"
          :params="merchants.params"
        ></list-table>
      </b-card>
    </div>
    <b-modal id="modal-1" title="لیست تسویه ها" size="lg" hide-footer>
      <list-table :fields="sattlements.fields" :url="sattlements.url" :params="sattlements.params"></list-table>
    </b-modal>
    <b-modal id="modal-2" title="درخواست تسویه" v-model="show">
      <b-form-group label="شماره شبا">
        <b-form-select v-model="selected" :options="options"></b-form-select>
      </b-form-group>
      <b-form-group label="مبلغ (ریال):">
        <div class="form-control">
          {{ summery.deposit.toLocaleString() }} ريال
        </div>
      </b-form-group>
      <template #modal-footer>
        <div class="">
          <b-button size="md" class="float-right" @click="show = false">
            انصراف
          </b-button>
        </div>
        <div class="">
          <b-button
            variant="primary"
            size="md"
            class="float-right"
            @click="SendCheckout"
          >
            درخواست تسویه
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import TableShowData from "../../components/table";
import persianDate from "@/helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_MY_PURCENT,
  GET_USER_CARD_LIST,
  SEND_CHECKOUT_REQUEST,
  GET_CHECKOUTING,
  GET_COUNT_MY_PURCENTS,
} from "@/core/services/store/mypurcent.module";
import _ from "lodash";
import httpHelper from "../../helpers/httpHelper";

export default {
  name: "IdentifierList",

  data() {
    return {
      summery: {},
      merchants: {
        fields: [
          {
            key: "gateway.user.name",
            label: "نام و نام خانوادگی مالک",
          },
          {
            key: "gateway.website_name",
            label: "وبسایت",
          },
          {
            key: "gateway.website",
            label: "آدرس وبسایت",
          },
          {
            key: "count_tr",
            label: "تعداد تراکنش ها",
            formatter(value, key, item) {
              return Number(value).toLocaleString();
            },
          },
          {
            key: "sum_amount",
            label: "مجموع درآمد دریافتی",
            formatter(value, key, item) {
              return Number(value).toLocaleString();
            },
          },
        ],
        params: [],
        url: "~ref/api/v1/income",
      },
      appId: `my.shepa.com/register?Id=${
        JSON.parse(localStorage.getItem("User")).id
      }`,
      show: false,
      canCopy: false,
      goallink: {},
      loading: false,
      selected: null,
      options: [],
      sattlements: {
        url: "~ref/api/v1/income/settlements",
        params: [],
        fields: [
          {
            key: "id",
            label: "کد درخواست",
          },
          {
            key: "name",
            label: "وضعیت",
            formatter(value, key, item) {
              if (item.tracking_number != null) return "پرداخت شده";
              else return "پرداخت نشده";
            },
          },
          {
            key: "amount",
            label: "مبلغ(ریال)",
            formatter(value, key, item) {
              return Number(-1 * value).toLocaleString();
            },
          },
          {
            key: "sattlement_iban",
            label: "شماره شبا",
          },
          {
            key: "tracking_number",
            label: "کد رهگیری",
          }
        ],
      },
      url: "~ref/api/v1/income/settlements",
      fields1: [
        {
          key: "name",
          label: "نام پذیرنده",
        },
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "website",
          label: "آدرس وبسایت",
        },
        {
          key: "lastPayment",
          label: "آخرین تاریخ پرداخت",
          formatter(value, key, item) {
            return persianDate.getDateByFormat(value);
          },
        },
        {
          key: "bess",
          label: "مجموع درآمد حاصل(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "beds",
          label: "درآمد تسویه شده(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
      ],
      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "name",
          label: "وضعیت",
          formatter(value, key, item) {
            if (item.child_document != null) return "پرداخت شده";
            else return "پرداخت نشده";
          },
        },
        {
          key: "bes",
          label: "مبلغ(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "detail.user_card.shaba_number",
          label: "شماره شبا",
        },
        {
          key: "child_document.doc_details[0].tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "created_at",
          label: "تاریخ درخواست",
          formatter(value, key, item) {
            return persianDate.getDateByFormat(value);
          },
        },
      ],
      param: {
        website: "",
        name: "",
      },
      params: [],
      dollarPrice: 0,
      isPaying: 0,
      ChartDatas: [],
      chartList: [],
      transCount: [],
      transSum: [],
      payable: 0,
      dataLoaded: false,
      sumAmount: 0,
      usercount: 0,
    };
  },
  components: {
    "list-table": TableShowData,
  },
  created() {
    this.canCopy = !!navigator.clipboard;
  },
  mounted() {
    this.dataLoaded = true;
    this.getSummery();
    this.getCountMyPurcents();
    this.getUserCardList();
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "کسب درآمد از شپا",
      },
    ]);
  },
  methods: {
    getSummery() {
      httpHelper.getData("~ref/api/v1/income/summery").then((res) => {
        this.summery = res.result;
      });
    },
    async copy(s) {
      await navigator.clipboard.writeText(s);
      this.$makeToast("success", "کپی لینک", `${this.appId}  کپی شد  `, 7000);
    },
    getCountMyPurcents() {
      this.$store.dispatch(GET_COUNT_MY_PURCENTS);
    },
    SendCheckout() {
      if (this.selected != null) {
        httpHelper
          .postData("~ref/api/v1/income/request-settlement", {
            sattlement_iban: this.selected,
            amount: this.summery.deposit,
          })
          .then((res) => {
            this.show = false;
            this.getSummery();
          });
      } else {
        this.$makeToast(
          "error",
          "خطا",
          "لطفا شماره شبای خود رو انتخاب کنید.",
          5000
        );
      }
    },
    getUserCardList() {
      // this.show = true;
      let obj = {};
      this.$store.dispatch(GET_USER_CARD_LIST).then((data) => {
        data.result.forEach((element) => {
          if (element.is_default === 1 && element.is_business_partners === 0) {
            this.selected = element.shaba_number;
          }
          if (element.is_business_partners === 0) {
            Object.assign(obj, {
              value: element.shaba_number,
              text: element.nickname + " " + element.shaba_number,
            });

            this.options.push(obj);
            obj = {};
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.guide p,
li {
  color: rgb(0, 0, 0);
  opacity: 0.6;
  font-size: 0.9rem;
}
</style>